import { Chain, get, post } from '@web3/utils';
import { MemberInfo, StakingTask, ThirdDepositInfo, Ticker, UserRegulationDTO, WalletBalance, WalletData, WalletTypesNumber } from './types';
import { memoize } from './wallet-hub/misc';

/** 获取钱包列表 */
export const queryWalletList = () => {
  return get<{
    totalAmountUsd: string;
    userId: string;
    walletDetail: WalletData[];
  }>('/web3/wallet/v1/private/mgmt/wallet/list');
};

/** 获取链列表 */
export const queryChainList = () => {
  return get<{
    walletChains: {
      CLOUD: { itemList: Chain[] };
      MNEMONIC_PHRASE: { itemList: Chain[] };
      MPC: {
        itemList: Chain[];
      };
    };
  }>('/web3/wallet/v2/private/mgmt/chain/list');
};

/** 创建云钱包 */
export const apiCreateBybitWallet = () => {
  return post('/spot/api/web3/wallet/v2/address/allocateCloudAddress');
};

/** staking活动列表 */
export const getStakingTaskList = () => {
  return get<StakingTask>('/spot/api/web3/content/staking/activity/get');
};

/** 获取utc时间 */
export const getUtcTime = () => {
  return get<{ currentTimeMillis: number }>('/spot/api/web3/ido/v1/system/time', {});
};

/**
 * 按链分组的地址类型
 */
export type AddressGroupByChainType = {
  address: string;
  chainIds: number[];
};

/**
 * 获取链余额列表的参数类型
 */
type GetChainBalanceListParams = {
  type: WalletTypesNumber;
  walletId: string;
  chainAddress: AddressGroupByChainType[];
  /** 资产自动发现，默认1，大于0则自动发现资产 */
  autoFindAsset?: number;
};

/**
 * 批量查询资产
 * @param param 查询参数
 * @returns 钱包余额信息
 */
export const getChainBalanceListAPI = async (param: GetChainBalanceListParams) => {
  const response = await post<WalletBalance>('/web3/wallet/v2/private/mgmt/asset/batchAllToken', param);
  return response;
};

/**
 * 获取账户信息
 * @description 中台接口
 */
export const getMemberInfo = () => {
  return get<MemberInfo>('/user/private/member/info');
};
/**
 * 获取token折U价格
 * @param params token列表
 * @returns
 */
export const getMarketTickers = (params: { symbol: string[] }) => {
  return get<Ticker[]>('/spot/api/quote/v1/ticker', {
    params: {
      symbol: params.symbol.map((s) => `301.${s.toUpperCase()}`).join(','),
    },
  });
};

/** 查询是否支持资金账户充值到云钱包 */
export const getThirdDepositInfo = (params: { chainCode: string; contractAddress: string }) => {
  return get<ThirdDepositInfo>('/spot/api/web3/wallet/exchangeWithdraw', { params });
};

/** 获取Compliance Regulation Info信息(人的user-site-id/refer-site-id/regulation-country) */
export const getComplianceRegulationInfo = memoize(() => {
  return get<UserRegulationDTO>('/compliance/v1/wall/regulation-info', {});
});

/** 获取用户主站的邀请人的邀请码 */
export const getThisUserInviteeCode = () => {
  return post<{ referralCode: string }>('/web3/wallet/v1/private/referral/getInviteeReferralCode');
};

/** 绑定钱包邀请关系 */
export const bindCloudWalletReferral = (params: { referralCode: string; walletId: string }) => {
  return post('/web3/wallet/v1/private/referral/bind', {
    ...params,
    walletType: 'CLOUD',
  });
};
/** 生成邀请码 */

export const produceReferralCode = (params: { walletId: string }) => {
  return post('/web3/wallet/v1/private/referral/produce', {
    ...params,
    walletType: 'CLOUD',
  });
};
